function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M116.641 410.73C82.0672 432.659 42.0006 444.253 0.778187 444.253V454.343C43.9189 454.343 85.8468 442.208 122.04 419.253C185.338 379.134 220.231 302.445 253.972 228.281C286.802 156.114 320.754 81.4932 380.414 43.7203C415.051 21.7909 455.118 10.1975 496.28 10.1975C554.219 10.1975 608.682 32.7657 649.629 73.7463C664.932 89.0619 677.806 106.479 687.895 125.513C689.198 127.971 692.249 128.906 694.708 127.605C697.167 126.3 698.105 123.247 696.801 120.786C686.242 100.871 672.773 82.6431 656.758 66.6147C613.906 23.7276 556.914 0.110352 496.28 0.110352C453.206 0.110352 411.278 12.2418 375.025 35.1933C312.825 74.5734 278.241 150.587 244.796 224.098L244.792 224.108C211.661 296.924 177.403 372.216 116.641 410.73Z",
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M116.641 410.73C82.0672 432.659 42.0006 444.253 0.778187 444.253V454.343C43.9189 454.343 85.8468 442.208 122.04 419.253C185.338 379.134 220.231 302.445 253.972 228.281C286.802 156.114 320.754 81.4932 380.414 43.7203C415.051 21.7909 455.118 10.1975 496.28 10.1975C554.219 10.1975 608.682 32.7657 649.629 73.7463C664.932 89.0619 677.806 106.479 687.895 125.513C689.198 127.971 692.249 128.906 694.708 127.605C697.167 126.3 698.105 123.247 696.801 120.786C686.242 100.871 672.773 82.6431 656.758 66.6147C613.906 23.7276 556.914 0.110352 496.28 0.110352C453.206 0.110352 411.278 12.2418 375.025 35.1933C312.825 74.5734 278.241 150.587 244.796 224.098L244.792 224.108C211.661 296.924 177.403 372.216 116.641 410.73Z",
  fill: "url(#paint35_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M987.059 0.0846252C1047.65 0.0846252 1104.64 23.7019 1147.54 66.589C1190.39 109.476 1213.99 166.515 1213.99 227.203C1213.99 287.846 1190.39 344.886 1147.54 387.81C1104.64 430.7 1047.65 454.317 987.059 454.317C931.877 454.317 878.698 434.278 837.314 397.887C835.225 396.047 835.016 392.86 836.854 390.769C838.692 388.677 841.877 388.472 843.966 390.308C883.509 425.082 934.326 444.23 987.059 444.23C1044.96 444.23 1099.42 421.662 1140.41 380.678C1181.36 339.661 1203.91 285.153 1203.91 227.203C1203.91 169.212 1181.36 114.708 1140.41 73.7239C1099.42 32.7433 1044.96 10.1751 987.059 10.1751C945.836 10.1751 905.77 21.7686 871.196 43.6979C810.431 82.2139 776.173 157.511 743.041 230.33C709.596 303.841 675.012 379.854 612.812 419.234C576.559 442.186 534.631 454.317 491.557 454.317C430.923 454.317 373.931 430.7 331.079 387.813C315.064 371.785 301.595 353.557 291.036 333.642C289.732 331.181 290.67 328.128 293.129 326.823C295.588 325.522 298.639 326.457 299.942 328.914C310.031 347.949 322.905 365.366 338.208 380.681C379.155 421.662 433.618 444.23 491.557 444.23C532.719 444.23 572.786 432.637 607.423 410.707C667.083 372.935 701.035 298.313 733.865 226.147C767.606 151.983 802.499 75.2942 865.797 35.1743C901.99 12.2195 943.918 0.0846252 987.059 0.0846252Z",
  fill: "url(#paint36_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M987.059 0.0846252C1047.65 0.0846252 1104.64 23.7019 1147.54 66.589C1190.39 109.476 1213.99 166.515 1213.99 227.203C1213.99 287.846 1190.39 344.886 1147.54 387.81C1104.64 430.7 1047.65 454.317 987.059 454.317C931.877 454.317 878.698 434.278 837.314 397.887C835.225 396.047 835.016 392.86 836.854 390.769C838.692 388.677 841.877 388.472 843.966 390.308C883.509 425.082 934.326 444.23 987.059 444.23C1044.96 444.23 1099.42 421.662 1140.41 380.678C1181.36 339.661 1203.91 285.153 1203.91 227.203C1203.91 169.212 1181.36 114.708 1140.41 73.7239C1099.42 32.7433 1044.96 10.1751 987.059 10.1751C945.836 10.1751 905.77 21.7686 871.196 43.6979C810.431 82.2139 776.173 157.511 743.041 230.33C709.596 303.841 675.012 379.854 612.812 419.234C576.559 442.186 534.631 454.317 491.557 454.317C430.923 454.317 373.931 430.7 331.079 387.813C315.064 371.785 301.595 353.557 291.036 333.642C289.732 331.181 290.67 328.128 293.129 326.823C295.588 325.522 298.639 326.457 299.942 328.914C310.031 347.949 322.905 365.366 338.208 380.681C379.155 421.662 433.618 444.23 491.557 444.23C532.719 444.23 572.786 432.637 607.423 410.707C667.083 372.935 701.035 298.313 733.865 226.147C767.606 151.983 802.499 75.2942 865.797 35.1743C901.99 12.2195 943.918 0.0846252 987.059 0.0846252Z",
  fill: "url(#paint37_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M987.059 0.0846252C1047.65 0.0846252 1104.64 23.7019 1147.54 66.589C1190.39 109.476 1213.99 166.515 1213.99 227.203C1213.99 287.846 1190.39 344.886 1147.54 387.81C1104.64 430.7 1047.65 454.317 987.059 454.317C931.877 454.317 878.698 434.278 837.314 397.887C835.225 396.047 835.016 392.86 836.854 390.769C838.692 388.677 841.877 388.472 843.966 390.308C883.509 425.082 934.326 444.23 987.059 444.23C1044.96 444.23 1099.42 421.662 1140.41 380.678C1181.36 339.661 1203.91 285.153 1203.91 227.203C1203.91 169.212 1181.36 114.708 1140.41 73.7239C1099.42 32.7433 1044.96 10.1751 987.059 10.1751C945.836 10.1751 905.77 21.7686 871.196 43.6979C810.431 82.2139 776.173 157.511 743.041 230.33C709.596 303.841 675.012 379.854 612.812 419.234C576.559 442.186 534.631 454.317 491.557 454.317C430.923 454.317 373.931 430.7 331.079 387.813C315.064 371.785 301.595 353.557 291.036 333.642C289.732 331.181 290.67 328.128 293.129 326.823C295.588 325.522 298.639 326.457 299.942 328.914C310.031 347.949 322.905 365.366 338.208 380.681C379.155 421.662 433.618 444.23 491.557 444.23C532.719 444.23 572.786 432.637 607.423 410.707C667.083 372.935 701.035 298.313 733.865 226.147C767.606 151.983 802.499 75.2942 865.797 35.1743C901.99 12.2195 943.918 0.0846252 987.059 0.0846252Z",
  fill: "url(#paint38_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M678.303 129.395C682.079 136.87 691.2 139.869 698.669 136.086C706.137 132.307 709.134 123.178 705.354 115.703C701.578 108.229 692.457 105.233 684.988 109.012C677.52 112.792 674.526 121.917 678.303 129.395Z",
  fill: "url(#paint39_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint35_linear",
  x1: -3.22813,
  y1: 227.226,
  x2: 697.39,
  y2: 227.226,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.3575,
  stopColor: "#16CABD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5472,
  stopColor: "#84848B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7095,
  stopColor: "#944CDC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7826,
  stopColor: "#FF36BB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint36_linear",
  x1: 1213.99,
  y1: 227.201,
  x2: 284.131,
  y2: 227.201,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2609,
  stopColor: "#7B3DD9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3807,
  stopColor: "#6260D2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6447,
  stopColor: "#24B7C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7005,
  stopColor: "#16CABD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint37_linear",
  x1: 1219.3,
  y1: 227.201,
  x2: 290.446,
  y2: 227.201,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.369792,
  stopColor: "#FF36BB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.484375,
  stopColor: "#944CDC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.744792,
  stopColor: "#84848B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.911458,
  stopColor: "#16CABD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint38_linear",
  x1: 1213.99,
  y1: 227.201,
  x2: 284.131,
  y2: 227.201,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2609,
  stopColor: "#7B3DD9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3807,
  stopColor: "#6260D2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6447,
  stopColor: "#24B7C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7005,
  stopColor: "#16CABD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint39_linear",
  x1: -226.152,
  y1: 122.548,
  x2: 703.708,
  y2: 122.548,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.2609,
  stopColor: "#7B3DD9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3807,
  stopColor: "#6260D2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6447,
  stopColor: "#24B7C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7005,
  stopColor: "#16CABD"
})));

function SvgRoadmapBg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1214 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapBg2);
export default __webpack_public_path__ + "static/media/roadmap-bg-2.80bb22b2.svg";
export { ForwardRef as ReactComponent };